import styled, { css } from 'styled-components';
import DefaultLabel from '~components/dumbs/Label';
import Column from '~components/dumbs/Column';
import { RelativeWrapperProps } from './types';
import DefaultErrorMessage from '~components/dumbs/ErrorMessage';

export const Label = styled(DefaultLabel)`
  margin-bottom: ${({ theme }) => theme.spacing.km1};
`;

export const ErrorMessage = styled(DefaultErrorMessage)`
  position: absolute;
  bottom: -18px;
`;

export const RelativeWrapper = styled(Column)<RelativeWrapperProps>`
  position: relative;
  ${({ $fieldGroupHasWidth }) =>
    $fieldGroupHasWidth &&
    css`
      width: 100%;
    `};

  input {
    ${({ error }) =>
      error &&
      css`
        border-color: ${({ theme }) => theme.color.border.danger.default};
      `};
    padding-right: ${({ theme }) => theme.spacing.km10};

    &:focus + * {
      svg {
        color: ${({ theme }) => theme.color.icon.neutral.strong};
      }
    }

    &:focus + svg {
      color: ${({ theme }) => theme.color.icon.neutral.strong};
    }
  }

  & > *:nth-child(2) {
    display: flex;
    cursor: pointer;
    right: ${({ theme }) => theme.spacing.km3};
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    color: ${({ theme }) => theme.color.icon.neutral.default};
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: 100%;
  }
`;

export const TrailGroup = styled.div`
  gap: ${({ theme }) => theme.spacing.km2};
`;

export const FieldGroup = styled(Column)`
  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: 100%;
  }
  position: relative;
`;
